import { CompactDropdownOptionProps } from '@/components/compactDropdown/CompactDropdown';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type Immer from '@reduxjs/toolkit/node_modules/immer';

export interface ISelectedBlock {
  id: string;
  title: string;
  description: string;
  branches: CompactDropdownOptionProps[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  versions: any;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Blocks = any[];

export type LicensingFeatures = {
  personalization?: {
    maxAudiences?: number;
    maxCustomAttributes?: number;
    maxSignals?: number;
  };
};
export interface ILicensingFeaturesState extends LicensingFeatures {
  isError?: boolean;
  error?: string;
  isLoading?: boolean;
}

const appSlice = createSlice({
  name: 'app',
  initialState: {
    selectedBlock: {} as ISelectedBlock | Record<string, never>,
    blocks: {
      error: false,
      payload: [] as Blocks,
      loading: false,
    },
    features: {} as ILicensingFeaturesState,
  },
  reducers: {
    SET_SELECTED_BLOCK(
      state,
      {
        payload,
      }: PayloadAction<{
        selectedBlock: ISelectedBlock | Record<string, never>;
      }>
    ) {
      state.selectedBlock = payload.selectedBlock;
    },
    SET_BLOCKS_LOADING(state) {
      state.blocks.loading = true;
    },
    SET_BLOCKS_ERROR(state, { payload }: PayloadAction<{ error: string }>) {
      state.blocks.loading = false;
      state.blocks.error = !!payload.error;
    },
    SET_BLOCKS_PAYLOAD(state, { payload }: PayloadAction<{ blocks: Blocks }>) {
      state.blocks.loading = false;
      state.blocks.payload = payload.blocks;
    },
    SET_FEATURES_LOADING(state) {
      state.features.isLoading = true;
    },
    SET_FEATURES_ERROR(state, { payload }: PayloadAction<{ error: string }>) {
      state.features = {
        isError: true,
        error: payload.error,
      };
    },
    SET_FEATURES_COMPLETE(
      state,
      { payload }: PayloadAction<{ features: LicensingFeatures }>
    ) {
      state.features = {
        isError: false,
        isLoading: false,
        ...payload.features,
      };
    },
  },
});

// Extract the action creators object and the reducer
export const { actions, name, reducer, getInitialState } = appSlice;

// Some TypeScript helper types
export type ActionTypeKeys = keyof typeof actions;

export type ActionType<T extends ActionTypeKeys = ActionTypeKeys> =
  `${typeof name}/${T}`;

export type ActionPayload<T extends ActionTypeKeys = ActionTypeKeys> = Omit<
  ReturnType<(typeof actions)[T]>,
  'type'
> & { type: ActionType<T> };

export default appSlice;
